import $ from 'jquery'
import Isotope from 'isotope-layout'

const wrapper = $('.usecase__isotope')
let iso

export const debounce = (fn, threshold) => {
    let timeout
    threshold = threshold || 100
    return function debounced() {
        clearTimeout(timeout)
        let args = arguments
        let _this = this
        function delayed() {
            fn.apply(_this, args)
        }
        timeout = setTimeout(delayed, threshold)
    }
}

function addTopMargin() {
    const filteredItems = iso.getFilteredItemElements();
    const items = filteredItems.length ? filteredItems : $('.usecase-isotope-item');
    $.each(items, function (index, item) {
        const $item = $(item);
        $item.css('marginTop', '0px');
        if (index === 1 && $(window).width() > 991) {
            const currentTop = parseInt($item.css('marginTop'), 10);
            const newTop = currentTop + 100;
            $item.css('marginTop', newTop + 'px');
        }
    });
}

if (wrapper.length) {
    let qsRegex
    window.addEventListener('load', () => {
        iso = new Isotope(wrapper[0], {
            itemSelector: '.usecase-isotope-item',
            percentPosition: true,
            masonry: {
                columnWidth: '.usecase-isotope--sizer',
            },
        })

        iso.on('arrangeComplete', addTopMargin);
        addTopMargin();
        iso.layout()

        $(window).resize(debounce(addTopMargin, 100));
    })

    const search = $('.search-field').keyup(
        debounce(function () {
            qsRegex = new RegExp(search.val(), 'gi')

            iso.arrange({
                filter: function () {
                    if ($(this).is('.entry-header-usecase__search')) {
                        return true
                    }
                    return qsRegex ? $(this).find('.feed-vehicle-range__name').text().match(qsRegex) : true
                },
            })

            if (search.val() === '') {
                iso.layout()
            }
        }, 200)
    )
}

